import * as React from 'react';
type Props = {
  className?: string;
};
export function Airfryer({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Airfryer"
      className={className}
    >
      <path
        d="M14.6875 22.1875H6.5625M13.4517 34.979L12.9058 36.9271C12.6853 38.0298 10.6155 37.9755 10.6155 37.9755C9.91972 38.0578 9.46375 37.7209 9.60203 37.2273L10.2323 34.979H13.4517ZM33.5063 16.5372V8.94849C33.5063 7.63834 32.7423 2.93774 27.6811 2.93774H12.4599C8.71416 2.93774 6.70212 5.56416 6.70212 8.40237V16.5372H6.68724V34.979H33.5212V16.5372H33.5063ZM29.9754 34.979L30.6064 37.2273C30.7447 37.7209 30.2887 38.0578 29.5929 37.9755C29.5929 37.9755 27.5231 38.0298 27.3026 36.9271L26.756 34.979H29.9754ZM33.5136 22.3239L25.9375 22.1875L33.5136 22.3239ZM25.6196 19.3921C25.7657 19.3921 25.8856 19.4534 25.8856 19.5278V25.1202C25.8856 25.1946 25.7657 25.2558 25.6196 25.2558L21.9578 25.2552L21.9578 29.6931C21.9578 32.1142 18.3773 32.1746 18.2538 29.8193L18.2506 29.6931L18.2503 25.2552L14.5888 25.2558C14.4609 25.2558 14.3531 25.2089 14.3282 25.1474L14.3228 25.1202V19.5278C14.3228 19.4534 14.4427 19.3921 14.5888 19.3921H25.6196ZM18.2506 22.4335V29.6931C18.2506 32.176 21.9578 32.1567 21.9578 29.6931V22.4335C21.9578 21.3771 18.2506 21.3395 18.2506 22.4335ZM15.3257 12.1482C15.3257 12.1814 15.4246 12.2085 15.5454 12.2085H19.9966H24.663C24.7838 12.2085 24.8827 12.1814 24.8827 12.1482V9.65388C24.8827 9.62063 24.7838 9.5935 24.663 9.5935H15.5454C15.4246 9.5935 15.3257 9.62063 15.3257 9.65388V12.1482Z"
        stroke="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2506 22.4334V29.6931C18.2506 32.176 21.9579 32.1567 21.9579 29.6931V22.4334C21.9579 21.3771 18.2506 21.3395 18.2506 22.4334Z"
        stroke="currentColor"
      />
    </svg>
  );
}
